import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=80ce0656&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=80ce0656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ce0656",
  null
  
)

export default component.exports